// Content sourced from public research on Graham Wetzbarger.
export const IMAGES = {
  portraitPrimary: "/graham-hero.jpg",
  portraitAlt: "/graham-hero.jpg",
  handbag:
    "https://images.unsplash.com/photo-1647960514922-052047430407?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  handbag2:
    "https://images.unsplash.com/photo-1637759292654-a12cb2be085e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  watch:
    "https://images.unsplash.com/photo-1768062251809-739d987a42fe?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  atelier:
    "https://images.unsplash.com/photo-1644258676710-ffb99d7d7a1b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  stone:
    "https://images.unsplash.com/photo-1606208594041-3dfd470247ce?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  jewelry:
    "https://static.prod-images.emergentagent.com/jobs/07c2dd63-9082-41b6-a5ba-c646e732a8fb/images/7cfb772cabce8cb134c8fdc4d84094983c00e81e484f5717d38dbc2aa0d9dd55.png",
  sneakers:
    "https://static.prod-images.emergentagent.com/jobs/07c2dd63-9082-41b6-a5ba-c646e732a8fb/images/959fd6c814d4152c75fe882a7304197eb81e4875b36666d9020f5782366c9ea4.png",
  couture:
    "https://images.unsplash.com/photo-1571924848943-25c2c95bbb4b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const HERO = {
  eyebrow: "Luxury Authentication · Appraisal · Advisory",
  name: "Graham\nWetzbarger",
  statement:
    "Two decades protecting the value of luxury — authenticating and appraising more than a billion dollars in handbags, watches, jewelry and couture.",
  location: "Newark, Delaware · Available Worldwide",
};

export const STATS = [
  { value: "$1B+", label: "Authenticated & appraised" },
  { value: "15+", label: "Years in luxury resale" },
  { value: "100+", label: "Authenticators led at The RealReal" },
  { value: "#50", label: "Employee at The RealReal" },
];

export const ABOUT = {
  lead:
    "Graham Wetzbarger is a globally recognized authority on luxury authentication and appraisal.",
  body: [
    "An art historian by training and a self-described fashion fanatic, Graham turned a lifelong obsession with craftsmanship into a career defining the standards of trust in the luxury resale market. As the 50th employee and Chief Authenticator at The RealReal, he built and led an authentication group of more than 100 experts and helped scale the company to a billion-dollar valuation.",
    "Today he is Founder & CEO of Luxury Appraisals & Authentication, Chief Authentication Officer at LUXUS, and co-founder of the Authentication Institute of America — the first program to offer formal scholarship in luxury authentication and counterfeit detection. He advises brands, law firms, investors and resale platforms, and serves as an expert witness in matters of fraud and intellectual property.",
  ],
  roles: [
    "Founder & CEO — Luxury Appraisals & Authentication",
    "Chief Authentication Officer — LUXUS",
    "Former Chief Authenticator — The RealReal",
    "Co-Founder — Authentication Institute of America",
  ],
};

export const PILLARS = [
  {
    n: "01",
    title: "Materials",
    desc: "The grain, weight and finish of leathers, textiles, metals and stones — verified by sight, touch and even scent.",
  },
  {
    n: "02",
    title: "Construction",
    desc: "Stitching, edge-painting, symmetry and assembly against each maison's documented standards.",
  },
  {
    n: "03",
    title: "Hardware",
    desc: "Zippers, clasps, engravings and plating examined for tooling marks and period-correct detail.",
  },
  {
    n: "04",
    title: "Brand Markers",
    desc: "Date codes, serials, fonts, holograms and heat-stamps cross-referenced across decades of reference.",
  },
];

export const SERVICES = [
  {
    title: "Authentication",
    summary: "Definitive verdicts on handbags, watches, jewelry, sneakers and ready-to-wear.",
    detail:
      "Category-specific authentication for individuals, platforms and brands — from a single grail piece to high-volume intake, backed by a documented four-pillar methodology.",
  },
  {
    title: "Appraisal & Valuation",
    summary: "USPAP-compliant appraisals for insurance, estate, donation and resale.",
    detail:
      "Formal, defensible valuations prepared to Uniform Standards of Professional Appraisal Practice, accepted by insurers, courts and institutions.",
  },
  {
    title: "Advisory & Consulting",
    summary: "Brand protection, resale strategy and circular-economy guidance.",
    detail:
      "Strategic counsel for resale platforms, investment firms and maisons on authentication programs, IP compliance and building operational trust at scale.",
  },
  {
    title: "Expert Witness",
    summary: "Litigation support in counterfeit, fraud and IP disputes.",
    detail:
      "Independent expert testimony and reporting for law firms and authorities — clear, credible and grounded in first-hand market expertise.",
  },
  {
    title: "Speaking & Education",
    summary: "Keynotes and training on authentication and the counterfeit economy.",
    detail:
      "Talks and curricula delivered at SXSW, the Fashion Law Institute, business schools and industry bodies, plus training programs for emerging authenticators.",
  },
];

export const CREDENTIALS = [
  { title: "AAA Certified", org: "Appraisers Association of America" },
  { title: "USPAP Compliant", org: "Uniform Standards of Professional Appraisal Practice" },
  { title: "AJP", org: "GIA — Accredited Jewelry Professional" },
  { title: "BFA, Fashion Design", org: "Pratt Institute · Minor, Art History" },
  { title: "Continuing Study", org: "Christie's Education · NYU · Fordham Law · LCF" },
  { title: "Board Chair", org: "Costume Society of America" },
  { title: "Member", org: "International Trademark Association" },
  { title: "Instructor", org: "Academy of Art University" },
];

export const PRESS = [
  "VOGUE",
  "THE WALL STREET JOURNAL",
  "FORBES",
  "CNN BUSINESS",
  "BLOOMBERG",
  "BUSINESS INSIDER",
  "ROBB REPORT",
  "ELLE",
  "REFINERY29",
  "HYPEBEAST",
  "CBS NEWS",
];

export const INQUIRY_TYPES = [
  "Authentication",
  "Appraisal & Valuation",
  "Advisory & Consulting",
  "Expert Witness",
  "Speaking & Education",
  "Media / Press",
  "Other",
];

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Expertise", href: "#expertise" },
  { label: "Services", href: "#services" },
  { label: "Press", href: "#press" },
  { label: "Contact", href: "#contact" },
];

export const CATEGORIES = [
  {
    title: "Handbags",
    desc: "Chanel, Hermès, Louis Vuitton and beyond — from contemporary to grail archive.",
    img: IMAGES.handbag,
  },
  {
    title: "Watches & Timepieces",
    desc: "Movement, case, dial and provenance verified against the maker's standards.",
    img: IMAGES.watch,
  },
  {
    title: "Fine Jewelry",
    desc: "Stones, metals, hallmarks and settings — GIA-trained assessment.",
    img: IMAGES.jewelry,
  },
  {
    title: "Sneakers & Streetwear",
    desc: "Hype and heritage releases authenticated for a fast-moving market.",
    img: IMAGES.sneakers,
  },
  {
    title: "Ready-to-Wear & Couture",
    desc: "Runway, seasonal and 20th-century couture across every maison.",
    img: IMAGES.couture,
  },
  {
    title: "Vintage & Archive",
    desc: "Designer vintage and rare archive pieces, dated and documented.",
    img: IMAGES.handbag2,
  },
];

export const QUOTE = {
  text:
    "Authenticity isn't a single tell — it's the sum of every detail. You learn to read materials, construction, hardware and brand markers with all your senses, until the truth is undeniable.",
  cite: "Graham Wetzbarger",
};

export const PRESS_ARTICLES = [
  {
    outlet: "The Wall Street Journal",
    title: "Inside Luxury Consignor The RealReal",
    url: "https://www.wsj.com/video/a-5000-secondhand-outfit-inside-luxury-consignor-the-realreal/A3813D55-3694-432A-AB9E-378E1279FDAB.html",
  },
  {
    outlet: "Forbes",
    title: "How The RealReal Created an Anxiety-Free Luxury Reseller Market",
    url: "https://www.forbes.com/sites/kristenphilipkoski/2014/10/31/how-the-realreal-created-an-anxiety-free-luxury-reseller-market/",
  },
  {
    outlet: "Bloomberg",
    title: "The Louis Vuitton Sneaker That Became Silicon Valley's Status Symbol",
    url: "https://www.bloomberg.com/news/articles/2017-03-20/this-louis-vuitton-sneaker-is-silicon-valley-s-latest-status-symbol",
  },
  {
    outlet: "Business Insider",
    title: "How To Spot Fake Designer Goods",
    url: "https://www.businessinsider.com/how-to-spot-fake-designer-goods-2018-12",
  },
  {
    outlet: "Glossy",
    title: "How the Resale Boom Created Demand for Skilled Authenticators",
    url: "https://www.glossy.co/fashion/the-hardest-thing-is-trust-how-the-resale-boom-has-created-a-demand-for-skilled-fashion-authenticators",
  },
  {
    outlet: "Robb Report",
    title: "Secondhand Never Looked So Chic",
    url: "https://robbreport.com/style/fashion/luxury-consignment-platform-the-realreal-opens-store-los-angeles-2813347/",
  },
];

export const FAQS = [
  {
    q: "What items do you authenticate?",
    a: "Handbags, watches, fine jewelry, sneakers and streetwear, and designer ready-to-wear and couture — across contemporary, vintage and archive pieces.",
  },
  {
    q: "What is a USPAP-compliant appraisal, and when do I need one?",
    a: "It is a formal valuation prepared to the Uniform Standards of Professional Appraisal Practice, accepted by insurers, courts, estates and donation authorities. You'll want one for insurance scheduling, estate settlement, charitable donation or resale.",
  },
  {
    q: "Do you work with brands and resale platforms?",
    a: "Yes. I advise maisons, marketplaces and investment firms on authentication programs, brand protection, IP compliance and building operational trust at scale.",
  },
  {
    q: "Can you serve as an expert witness?",
    a: "Yes. I provide independent expert reports and testimony in counterfeit, fraud and intellectual-property matters for law firms and authorities.",
  },
  {
    q: "How do I get started?",
    a: "Send a note through the contact form with a few details and photographs where possible. Graham's office will respond personally to scope the engagement.",
  },
];
